/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { CarouselApi } from "@packages/ui";
import { Carousel } from "@packages/ui";
import type { PropsWithChildren } from "react";
import { useRef } from "react";

const carouselStyle: Interpolation = {
  maxWidth: "500px",
};
const carouselContainerStyle: Interpolation = {
  placeItems: "center",
};
const itemStyle: Interpolation = {
  display: "flex",
  placeContent: "center",
  placeItems: "center",
};
/**
 * This component exists because calling `useCarousel` when the <Carousel> isn't rendered
 * leads to a situation where the IntersectionObserver is never attached to the carousel
 * properly, and a bunch of functionality stops working. Having it in a separate component
 * means it renders and calls `useCarousel` at the appropriate time.
 * @param {ReactNode} children The post-prayer steps
 * @param {(childIdx: number|null) => void} onVisible
 * @constructor
 */
export const ModalCarousel = ({
  children,
  onVisible,
  carouselApi,
}: PropsWithChildren<{
  onVisible: (childIdx: number | null) => void;
  carouselApi: CarouselApi;
}>) => {
  const viewportRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={viewportRef}>
      <Carousel
        carouselApi={carouselApi}
        css={carouselStyle}
        containerCSS={carouselContainerStyle}
        visibilityProps={{
          onVisible,
          viewportRef,
          observerProps: {
            rootMargin: "24px 24px 24px 24px",
          },
        }}
        itemCSS={itemStyle}
      >
        {children}
      </Carousel>
    </div>
  );
};
